import React from 'react';
import AppActions from '../../actions/app-actions';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { isEmpty } from '../../helpers';
import ExpandJsonView from '../configurations/expand-json-view';

export default class ExpandedConfig extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showConfigDlg: false,
      showAiPackageConfig: false,
      configInfo: null
    }
  }

  componentDidMount() {}

  //Used to display selected config in json-view
  toggleShowConfigDlg(showConfigDlg, type) {
    this.setState({ showConfigDlg });
    if(showConfigDlg === true) {
      let device = this.props.device;
      const {configInfo, localConfInfo} = device;
      if (type === 'config') {
        const configDetails = configInfo.configuration.config_details;
        let configInfoJson = configDetails !== undefined && configDetails !== null && configDetails !== ''
          ? JSON.parse(configDetails) : '';
        this.setState({configInfo: configInfoJson});
      } else if (type === 'flavor') {
        this.setState({configInfo: JSON.parse(configInfo.flavor.container)});
      } else if (type === 'local') {
        //MP TODO: Need to test this
        this.setState({configInfo: (!isEmpty(localConfInfo) ? JSON.parse(localConfInfo.config_details): {})});
      } else if (type === 'ai') {
        let info = {};

        if (device.localConfInfo.ai_package && Array.isArray(device.localConfInfo.ai_package)) {
          for (let i = 0; i < device.localConfInfo.ai_package.length; i++) {
            if (device.localConfInfo.ai_package[i].type === 'engine') {
              // eslint-disable-next-line no-unused-vars
              const { type, ...rest } = device.localConfInfo.ai_package[i];
              info = { ...rest };
            }
          }
        }

        this.setState({configInfo: info})
      }
      //this.props.pause();
    }
  }

  toggleShowAiPackageConfig () {
    this.setState
  }

  getAIEngineName() {
    let device = this.props.device;

    if (device.localConfInfo.ai_package && Array.isArray(device.localConfInfo.ai_package)) {
      for (let i = 0; i < device.localConfInfo.ai_package.length; i++) {
        if (device.localConfInfo.ai_package[i].type === 'engine') {
          return device.localConfInfo.ai_package[i].name
        }
      }
    }

    return 'None deployed!'
  }

  render() {
    const self = this;
    const {device} = self.props;
    const configName = self.props.configName || device.configInfo.configuration.name || 'Config Info';
    const flavorName = self.props.flavorName || device.configInfo.flavor.name || 'Flavor Info';
    const showConfigDlgTitle = 'Config Information';
    const buttonStyle = { textTransform: 'none', textAlign: 'left' };
    var showConfigDlgActions = [
      <Button key="config-button-1" style={{ marginRight: '10px', display: 'inline-block' }} onClick={() => this.toggleShowConfigDlg(false)}>
        Close
      </Button>
    ];

    return (
      <div className="margin-bottom-small flexbox" style={{ flexDirection: 'row' }}>

        <Button style={{ width: '100%', height: '10%' }}
          onClick={() => {
            this.toggleShowConfigDlg(true, 'ai')
          }}
        >
          <span className="inline-block">
            <Typography component="span" variant="subtitle1" style={buttonStyle}>
              AI Package
            </Typography>
            <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
              { this.getAIEngineName() }
            </Typography>
          </span>
        </Button>

        <Button style={{ width: '100%', height: '10%' }}
          onClick={() => {
            this.toggleShowConfigDlg(true, 'flavor');
            AppActions.setSnackbar('');
          }}
        >
          <span className="inline-block">
            <Typography component="span" variant="subtitle1" style={buttonStyle}>
              {flavorName}
            </Typography>
            <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
              Click to view flavor
            </Typography>
          </span>
        </Button>

        <Button style={{ width: '100%', height: '10%' }}
          onClick={() => {
            this.toggleShowConfigDlg(true, 'config');
            AppActions.setSnackbar('');
          }}
        >
          <span className="inline-block">
            <Typography component="span" variant="subtitle1" style={buttonStyle}>
              {configName}
            </Typography>
            <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
              Click to view config
            </Typography>
          </span>
        </Button>
        <Button style={{ width: '100%', height: '10%' }}
          onClick={() => {
            this.toggleShowConfigDlg(true, 'local');
            AppActions.setSnackbar('');
          }}
        >
          <span className="inline-block">
            <Typography component="span" variant="subtitle1" style={buttonStyle}>
              Local Config Info
            </Typography>
            <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
              Click to view
            </Typography>
          </span>
        </Button>
        <Dialog
          open={this.state.showConfigDlg}
          maxWidth="lg"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden'
          }}
        >
          <DialogTitle>{showConfigDlgTitle}</DialogTitle>
          <DialogContent>
            <Divider />
            <ExpandJsonView
              config={this.state.configInfo || {}}
              name={null}
              enableClipboard={false}
              onAdd={false}
              onEdit={false}
              onDelete={false}
            />
          </DialogContent>
          <DialogActions>{showConfigDlgActions}</DialogActions>
        </Dialog>
      </div>
    )
  }
}
